import { Heading } from "@medoma/components/Heading/Heading";
import styles from "./Header.module.scss";
import type {
  BackButton,
  CloseButton,
} from "../NavigationButtons/NavigationButtons";

export type NavigationButtons = {
  backButton?: React.ReactElement<typeof BackButton>;
  closeButton?: React.ReactElement<typeof CloseButton>;
};

type DetailsPanelHeaderProps = {
  icon: React.ReactNode;
  title: React.ReactNode;
  navigationButtons?: NavigationButtons;
};

export const DetailsPanelHeader = ({
  icon,
  title,
  navigationButtons,
}: DetailsPanelHeaderProps) => {
  const { backButton, closeButton } = navigationButtons ?? {};

  return (
    <div className={styles.header}>
      {backButton ? backButton : null}
      <div className={styles.title}>
        {icon}
        <Heading level="h1" size="base" weight="regular">
          {title}
        </Heading>
      </div>
      <div className={styles.closeButton}>
        {closeButton ? closeButton : null}
      </div>
    </div>
  );
};
